import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import io from 'socket.io-client';

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
    
    const ws = useRef(null);
    const [isConnected, setIsConnected] = useState(false);

    useEffect(() => {
        const userId = JSON.parse(sessionStorage.getItem('user'))?.cod_usuario || JSON.parse(sessionStorage.getItem('projeto'))?.usuario;
        const cdId = JSON.parse(sessionStorage.getItem('user'))?.cod_cd || JSON.parse(sessionStorage.getItem('cd'))?.cod_cd;
        const token = sessionStorage.getItem('token');
        const wsUrl = process.env.REACT_APP_WS;
        const extraHeaders = { 
            // Host: '<calculated at runtime>',
            Authorization: `Bearer ${token}`,
            // Connection: 'Upgrade',
            // Upgrade: 'websocket',
            // 'Sec-WebSocket-Key': '<calculated at runtime>',
            // 'Sec-WebSocket-Version': 13,
            // 'Sec-WebSocket-Extensions': 'permessage-deflate; client-max-window-bits',
        };

        // Inicializa o WebSocket apenas uma vez
        ws.current = io(wsUrl, { extraHeaders, query: { userId, cdId } });

        ws.current.on('connect', () => setIsConnected(true));

        return () => {
            // Fecha a conexão ao desmontar o provider
            ws.current.close();
        };
    }, []);

    const addEvent = useCallback((event, callback) => {
        ws.current && ws.current.on(event, callback);
    }, []);

    const removeEvent = useCallback((event, callback) => {
        ws.current && ws.current.off(event, callback);
    }, []);

    const emitEvent = useCallback((event, ...params) => {
        ws.current && ws.current.emit(event, ...params);
    }, []);

    return (
        <WebSocketContext.Provider value={{ addEvent, removeEvent, emitEvent, isConnected }}>
            {children}
        </WebSocketContext.Provider>
    );
};

// Hook para usar o WebSocketContext em outros componentes
export const useWebSocket = () => {
    return useContext(WebSocketContext);
};
